import { render } from "./LwToastRegion.vue?vue&type=template&id=479d0970&scoped=true"
import script from "./LwToastRegion.vue?vue&type=script&lang=js"
export * from "./LwToastRegion.vue?vue&type=script&lang=js"

import "./LwToastRegion.vue?vue&type=style&index=0&id=479d0970&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-479d0970"]])

export default __exports__